"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.api = void 0;
const axios_1 = require("axios");
exports.api = {
    post: async (url, data) => {
        try {
            const config = {
                headers: {
                    'Content-Type': 'application/jsontoxml',
                    'Cache-Control': 'no-cache'
                },
            };
            const response = await axios_1.default.post(url, data, config);
            return response;
        }
        catch (error) {
            throw error;
        }
    },
    postCertificate: async (url, data) => {
        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json'
                },
            };
            const response = await axios_1.default.post(url, data, config);
            return response;
        }
        catch (error) {
            throw error;
        }
    },
    get: async (url) => {
        try {
            const response = await axios_1.default.get(url);
            return response;
        }
        catch (error) {
            throw error;
        }
    },
};
//# sourceMappingURL=api.js.map